import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchProducts } from '../requests';
import Product from '../components/Product';
import ProductInfo from '../components/ProductInfo';
import DaneModeluNaOfercie from '../components/DaneModeluNaOfercie';
import BreadcrumbsComponent from '../components/Breadcrumbs';
import Loader from '../components/Loader';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { ZachetyWMarginesach, ZachetyWTresci } from '../components/promo/ZachetyModelu';
import { seriesFromMatchKey } from '../utils';

const InverterDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  // Nazwa doczytuje sie z API, wiec do czasu odpowiedzi
  // zakladka pokazuje kategorie zamiast golego „VoltValue".
  useDocumentTitle(product?.name || 'Falownik');
  const [model, setModel] = useState(null);
  const [otherOffers, setOtherOffers] = useState([]);
  const [modelSeries, setModelSeries] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      const data = await fetchProducts(`get_inverter/${id}`);
      if (cancelled) return;
      setProduct(data && !data.error ? data : null);
      setLoading(false);
      if (data && data.model_id != null) {
        const model = await fetchProducts(`get_inverter_model/${data.model_id}`);
        if (cancelled) return;
        setModel(model && !model.error ? model : null);
        const offers = (model && model.offers) || [];
        setOtherOffers(offers.filter((o) => String(o.id) !== String(id)));
        // Seria = znormalizowane pole z API (warianty AM2/SM2/BM3 scalone, klasa
        // napięcia w nawiasie); seriesFromMatchKey to fallback dla starszych odpowiedzi.
        setModelSeries(model ? (model.series || seriesFromMatchKey(model.match_key)) : null);
      } else {
        setModel(null);
        setOtherOffers([]);
        setModelSeries(null);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [id]);

  if (loading) return (<div className='fixed inset-0 flex justify-center items-center'><Loader /></div>);
  if (!product) return <div className="px-4 lg:px-24 mt-10 text-gray-500">Nie znaleziono produktu.</div>;

  return (
    <div className="relative">
      {/* Zachęty dalej, jak na karcie modelu (2026-10-08): w marginesach od 1840 px, węższe ekrany na dole strony. */}
      <ZachetyWMarginesach kategoria="inwerter" modelId={product.model_id} />
      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-10">
        <BreadcrumbsComponent parentLabel="Falowniki" parentTo="/inwertery" currentLabel={product.name} />
      </div>
      <ProductInfo product={product} productType="inwerter" modelSeries={modelSeries} />
      <DaneModeluNaOfercie model={model} category="inwerter" />
      {otherOffers.length > 0 && (
        <div className="max-w-5xl mx-auto px-4 md:px-8 mb-16">
          <h2 className="text-lg sm:text-xl font-bold text-blue-600 mb-4">Inne oferty tego produktu <span className="text-blue-400 font-normal">({otherOffers.length})</span></h2>
          <ul>{otherOffers.map((o) => (<Product key={o.id} product={o} productType="inwerter" compact />))}</ul>
        </div>
      )}
      <div className="max-w-5xl mx-auto px-4 md:px-8 mb-16">
        <ZachetyWTresci kategoria="inwerter" modelId={product.model_id} />
      </div>
    </div>
  );
};

export default InverterDetails;
